module.exports = __webpack_public_path__ + "static/media/RUSSELL K. RED 150 LOUDSPEAKERS.b7241bd5.png";